import { css } from '@emotion/react';
import { useMemo } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const borderWidth = 1;
const borderRadius = 16;
const buttonHeight = 32;
const variationStyles = {
    collapse: {
        backgroundColor: theme.colors.surfaceSystemPrimary,
        hoverBackgroundColor: theme.colors.surfaceSystemSecondaryHover,
    },
    expand: {
        backgroundColor: theme.colors.surfaceSystemAccent,
        hoverBackgroundColor: theme.colors.surfaceSystemSecondaryHover,
    },
};
export const useExpandableButtonStyles = ({ modifier, }) => {
    const expandableButtonStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        ${styleUtils.borderBox}
        ${styleUtils.transition('background-color')}
        ${theme.typeStyles.captionMediumStyles}
        align-items: center;
        column-gap: ${theme.spacing.base};
        display: inline-flex;
        background-color: ${variationStyles[modifier].backgroundColor};
        border-color: ${theme.colors.borderDefault};
        border-radius: ${styleUtils.rem(borderRadius)};
        border-style: solid;
        border-width: ${styleUtils.rem(borderWidth)};
        height: ${styleUtils.rem(buttonHeight)};
        padding-bottom: ${theme.spacing.x2};
        padding-left: ${theme.spacing.x3};
        padding-right: ${theme.spacing.x3};
        padding-top: ${theme.spacing.x2};
        white-space: nowrap;

        &:focus,
        &:hover {
          background-color: ${variationStyles[modifier].hoverBackgroundColor};
          border-color: ${theme.colors.borderHover};
          cursor: pointer;
          text-decoration: none;
        }
      `), [
        modifier,
    ]);
    return expandableButtonStyles;
};
